// REACT
import { useContext, useEffect, useState } from "react";

// CUSTOM HOOKS
import { useRead } from "../../hooks/useFetch";

// COMPONENTS
import SingleProduct from "./SingleProduct";
import ProductForm from "./ProductForm";
import Loading from "../common/Loading";

// SERVICES
import modalHandler from "../../services/modalHandler";

// ASSETS
import "../../assets/styles/productsList.css";
import { FaPlus } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { maincontext } from "../../context/maincontext";
import languagePack from "../../assets/languages/languagePack";

export default function ProductsList(params) {
    const { language, token } = useContext(maincontext)

    // MODAL
    const [showModal, setShowModal] = useState(false);
    const [modalItem, setModalItem] = useState(null);

    // FETCH
    const productsUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}products`;
    const [refetchTrigger, setRefetchTrigger] = useState(false);
    const products = useRead(productsUrl, refetchTrigger);

    // RENDER VARS
    const [productsRender, setProductsRender] = useState(null);

    useEffect(() => {
        if (products.data && !products.isPending) {
            setProductsRender(products.data);
        } else if (products.error) {
            console.log(products.error);
        }
    }, [products.data, products.isPending, products.error]);

    const groupedProducts = productsRender?.reduce((acc, product) => {
        const group = product.product_group || "Others";
        if (!acc[group]) {
            acc[group] = [];
        }
        acc[group].push(product);
        return acc;
    }, {});

    return (
        <>
            {products.isPending || token == null ?
                <Loading /> :
                <>
                    {showModal && <>{modalItem}</>}

                    {/* Header with "Create" Button */}
                    <div className="table-header">
                        <h3>{languagePack[language].productManager.listTitle}</h3>
                        <Button
                            variant="primary"
                            className="create-btn"
                            onClick={() => {
                                modalHandler(
                                    <ProductForm
                                        setShowModal={setShowModal}
                                        isEdit={false}
                                        setRefetchTrigger={setRefetchTrigger}
                                    />,
                                    setModalItem,
                                    true,
                                    setShowModal
                                )
                            }}>
                            <FaPlus className="create-icon" />&nbsp; {languagePack[language].common.add}
                        </Button>
                    </div>

                    {products.error && <h4 className="productError">{products.error}</h4>}
                    {groupedProducts && Object.keys(groupedProducts).length === 0 && !products.error && (
                        <h4 className="noProducts">{languagePack[language].productManager.noProduct}</h4>
                    )}

                    <div className="table-container">
                        {groupedProducts &&
                            Object.entries(groupedProducts).map(([group, products]) => (
                                <div key={group} className="product-group">
                                    <h3>{group}</h3>
                                    <div className="table-scroll">
                                        <Table striped bordered hover responsive className="product-table">
                                            <thead>
                                                <tr>
                                                    <th>{languagePack[language].productManager.prdName}</th>
                                                    <th>{languagePack[language].productManager.sku}</th>
                                                    <th>{languagePack[language].productManager.actions}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.map((product) => (
                                                    <SingleProduct
                                                        key={product.id}
                                                        product={product}
                                                        setShowModal={setShowModal}
                                                        setModalItem={setModalItem}
                                                        setRefetchTrigger={setRefetchTrigger}
                                                    />
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            ))}
                    </div>

                </>
            }
        </>
    );
}
